import {useCallback, useEffect, useRef, useState} from "react";
import axiosInstance from "../../config/axios-config";

export default function useProductCatalogue(language) {
    const [query, setQuery] = useState({search: "", page: 0});
    const [result, setResult] = useState({status: "loading", rows: [], total: null, pages: 0});
    const request = useRef(null);
    const reload = useCallback(async () => {
        request.current?.abort();
        const controller = new AbortController();
        request.current = controller;
        setResult({status: "loading", rows: [], total: null, pages: 0});
        try {
            const {data} = await axiosInstance.get("/api/v1/product_tenants/current", {signal: controller.signal,
                timeout: 10000, headers: {"Language-Context": (language || "en").toUpperCase()},
                params: {searchTerm: query.search || null, page: query.page, size: 10}});
            if (controller.signal.aborted) return;
            if (!Array.isArray(data?.content) || !Number.isSafeInteger(data.totalPages) || data.totalPages < 0 ||
                data.content.some(row => !row.productTenantId)) throw new Error("Invalid product page");
            if (query.page > 0 && query.page >= data.totalPages) {setQuery(previous => ({...previous, page: Math.max(0, data.totalPages - 1)})); return;}
            if ((data.totalPages === 0 && data.content.length > 0) || (data.totalPages > 0 && query.page === 0 && !data.content.length))
                throw new Error("Inconsistent product page");
            setResult({status: "success", rows: data.content, pages: data.totalPages,
                total: Number.isSafeInteger(data.totalElements) && data.totalElements >= 0 ? data.totalElements : null});
        } catch (error) {
            if (!controller.signal.aborted) setResult({status: "error", rows: [], total: null, pages: 0,
                error: error.response?.data?.message || "DistributorProductsFailed"});
        }
    }, [language, query]);
    useEffect(() => {reload(); return () => request.current?.abort();}, [reload]);
    const updateRow = row => setResult(previous => ({...previous,
        rows: previous.rows.map(item => item.productTenantId === row.productTenantId ? row : item)}));
    return {...result, query, setQuery, reload, updateRow};
}
